import { extend } from 'underscore';
import {
  paginationStyle,
  getColumnSolidBorderStyle,
} from '@bingads-webui-campaign-react/common-styles';

const fontFamily = '"MsAds MDL2 Assets"';

export const getMasStyle = () => ({
  multipleAccountSelector: {
    padding: 10,
    width: 870,
    border: 0,
    borderRadius: 2,
    boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
    backgroundColor: '#fff',

    '& .ba-search-box .search-box__icon': {
      overflow: 'visible !important',
      textDecoration: 'none !important',
      background: 'none !important',
      top: 3,
      marginTop: 5,
      position: 'absolute',
      right: 6,
      fontSize: 12,
      height: 15,
      width: 20,
    },
    '& .ba-search-box .search-box__icon:hover': {
      cursor: 'pointer',
    },
    '& .ba-search-box .search-box__icon:before': {
      fontFamily,
      content: '"\\E721"',
      fontSize: 14,
      display: 'inline-block',
      fontWeight: 'normal',
      fontStyle: 'normal',
      textDecoration: 'inherit',
      speak: 'none',
      fontVariant: 'normal',
      textTransform: 'none',
      verticalAlign: 'top',
      lineHeight: 1,
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },

    '& .glyph-close': {
      overflow: 'visible !important',
      textDecoration: 'none !important',
      background: 'none !important',
      paddingTop: 3,
    },
    '& .glyph-close:before': {
      fontFamily,
      content: '"\\E711"',
      display: 'inline-block',
      fontWeight: 'normal',
      fontStyle: 'normal',
      textDecoration: 'inherit',
      speak: 'none',
      fontVariant: 'normal',
      textTransform: 'none',
      verticalAlign: 'top',
      lineHeight: 1,
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },

    '& .actions': {
      marginTop: 20,
      '& .apply, & .cancel': {
        margin: 8,
      },
    },
    '& .glyphicon-triangle-right:before': {
      content: '"\\E70D"',
      fontFamily,
      fontSize: '12px',
      marginRight: '8px',
      marginTop: '2px',
    },
    '& .glyphicon-triangle-bottom:before': {
      content: '"\\E76C"',
      fontFamily,
      fontSize: '12px',
      marginRight: '8px',
      marginTop: '2px',
    },

    '& .glyph-shift-right:after': {
      fontFamily,
      content: '"\\E76C"',
      float: 'right',
    },

    '& .glyph-shift-left:after': {
      fontFamily,
      content: '"\\E76B"',
      float: 'left',
    },

    '& .glyph-shift-right, & .glyph-shift-left': {
      verticalAlign: '-5px !important',
    },
  },
});

const iconFontFamily = 'MsAds MDL2 Assets';

export const getAccountSelectorStyle = (_, { palette = {} }) => ({
  gridCustomStyles: getColumnSolidBorderStyle(0, 2),
  topGridPanelCustomStyles: paginationStyle({ palette, iconFontFamily }),
  '@global': extend({
    '.dimensions-table td.text-left': {
      wordWrap: 'break-word',
      wordBreak: 'break-word',
    },
  }),
  accountSelectorPopover: {
    padding: 0,
    margin: 0,
    height: 0,
    width: 0,
    border: 0,
    '& .arrow': {
      display: 'none',
    },

    '& .hidden': {
      display: 'none',
    },

    '& .popover-content': {
      fontSize: 14,
      float: 'right',
      height: 0,
      padding: 0,
      margin: 0,

      '& .account-selector-popup': {
        height: 538,
      },
    },
  },

  userInputScope: {
    padding: 10,
    '& .actions': {
      marginTop: 20,
      '& button': {
        margin: 8,
      },
    },
  },

  customToolbarItem: {
    flex: '0 0 auto',
    border: 'none',
    height: 56,
    fontSize: 14,
    fontWeight: 'unset !important',
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,

    '& .text': {
      verticalAlign: 'text-bottom',
    },

    '& .caret': {
      height: 20,
      paddingLeft: 4,
      top: -1,
      '&:before': {
        content: '"\\E70D"',
        fontFamily: iconFontFamily,
      },
    },
  },

  downloadIcon: {
    margin: '0 4px',
    color: palette.themeDarkAlt,

    '&:before': {
      content: '"\\E896"',
      fontFamily: iconFontFamily,
    },
  },
});
